import { useQueries } from 'react-query';
import { Analyst } from '../../models';
import { fetchAnalyst } from '../../services/analysts/analysts.service';

interface QueriesResult {
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  data: Analyst[];
}

const isAnalyst = (item: Analyst | undefined): item is Analyst => {
  return !!item;
};

interface UseFetchAnalystsOptions {
  analystIds: string[];
  enabled?: boolean;
}

export default ({ analystIds, enabled = true }: UseFetchAnalystsOptions): QueriesResult => {
  const results = useQueries(
    analystIds.map((id) => {
      return {
        queryKey: ['fetchAnalyst', id],
        queryFn: () => fetchAnalyst(id),
        retryOnMount: false,
        enabled,
      };
    })
  );

  const isLoading = results.some((r) => r.isLoading);
  const isError = results.some((r) => r.isError);
  const isSuccess = results.every((r) => r.isSuccess);

  return {
    isLoading,
    isError,
    isSuccess,
    data: results.map((r) => r.data).filter(isAnalyst),
  };
};
